var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3342 13L34 18.8L32.6214 19.1467C31.9752 17.9867 31.3146 16.8267 30.5535 16.24C29.7924 15.6667 28.9021 15.6667 28.0261 15.6667H24.436V29.6667C24.436 30.3333 24.436 31 24.9099 31.3333C25.3982 31.6667 26.346 31.6667 27.3081 31.6667V33H18.6919V31.6667C19.654 31.6667 20.6018 31.6667 21.0901 31.3333C21.564 31 21.564 30.3333 21.564 29.6667V15.6667H17.9739C17.0979 15.6667 16.2076 15.6667 15.4465 16.24C14.6854 16.8267 14.0248 17.9867 13.3786 19.1467L12 18.8L13.6658 13H32.3342Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.55de5b39e633d052d3e44954e6600956.svg";
export { ForwardRef as ReactComponent };